<template>
  <footer class="mx-5 flex items-center justify-center flex-shrink-0 flex-grow-0 text-center">
    <p class="mt-5 mb-10 whitespace-normal text-gray-600 text-base">
      {{ $t('common.clienia-ag', { year: new Date().getFullYear() }) }}
    </p>
  </footer>
</template>
